<h2 mat-dialog-title class="service-obs-dialog__title">
  Editar Observaciones
</h2>

<mat-dialog-content class="service-obs-dialog__body">
  <p class="service-obs-dialog__label">Ingrese las observaciones del servicio:</p>

  <textarea
    class="service-obs-dialog__input"
    [formControl]="observacionesControl"
    rows="4"
    maxlength="500"
    placeholder="Observaciones"
    autocomplete="off"
  ></textarea>

  <p
    *ngIf="
      observacionesControl.hasError('maxlength') &&
      observacionesControl.touched
    "
    class="service-obs-dialog__error"
  >
    Las observaciones no pueden superar los 500 caracteres.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="center" class="service-obs-dialog__actions">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button
    mat-flat-button
    class="buttonPrimary"
    (click)="saveObservaciones()"
    [disabled]="loader"
  >
    <mat-spinner *ngIf="loader" [diameter]="18"></mat-spinner>
    <span *ngIf="!loader">Guardar</span>
  </button>
</mat-dialog-actions>
